export const AGE_ALERT_DAYS = 5;
export const IDLE_ALERT_DAYS = 3;

export const EMAIL_PLACEHOLDER = "{email}";

export const PRICE_REMARK_EXPORT_MESSAGES = {
  EMPTY_NETWORK: "Nenhuma loja com pendência nesta janela.",
  EMPTY_ITEMS: "Nenhum item pendente para este filtro.",
  EMPTY_LABEL_AUDIT: "Nenhuma etiqueta no período para esta loja.",
  LABEL_AUDIT_ERROR:
    "Não foi possível solicitar a auditoria. Tente novamente.",
  QUEUED: `A planilha está sendo gerada e chegará em ${EMAIL_PLACEHOLDER} e nas suas notificações.`,
  NETWORK_ERROR:
    "Não foi possível solicitar a exportação das pendências. Tente novamente.",
  ITEMS_ERROR:
    "Não foi possível solicitar a ordem de trabalho. Tente novamente.",
} as const;
